import {
  Stack,
  InputWrapper,
  Select,
  Title,
  Group,
  NumberInput,
  Text,
} from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"

import {
  DigestConfig,
  DigestOneTimeConfig,
} from "@costory/types/endpoints/digest"

import { QueryBuilderWrapper } from "@costory/front/components/QueryBuilderWrapper"

export const DigestConfigStep2 = ({
  form,
}: {
  form: UseFormReturnType<DigestOneTimeConfig | DigestConfig>
}) => {
  return (
    <Stack>
      <Title order={5}> Cost Column </Title>
      <Text>
        Use this to select the cost column to use for the analysis. If you want
        to ignore savings plan and credits you can rely on contracted cost. n
        most cases, you should use cost.
      </Text>
      <Select
        {...form.getInputProps("costColumn")}
        data={[
          { value: "cost", label: "Cost" },
          { value: "contracted_cost", label: "Contracted Cost" },
          { value: "list_cost", label: "List Cost" },
        ]}
        placeholder="Select a cost column"
        searchable
        clearable
        size="md"
        radius="md"
      />
      <Title order={5}>Select what you want to analyze </Title>
      <Text>
        Use this to filter the data used to generate the digest. You can use the
        same filters as in the Explorer.
      </Text>
      <QueryBuilderWrapper
        defaultValue={form.values.whereClause}
        onChange={(query) => {
          form.setFieldValue(
            "whereClause",
            query ?? { rules: [], combinator: "AND" },
          )
        }}
      />
      <Title order={5}> Define the thresholds </Title>
      <Text>
        Use this to define the thresholds for the analysis. Items smaller will
        be aggregated into &quot;Others&quot;
      </Text>
      <Group justify="center" gap="xl">
        <InputWrapper label="Absolute difference threshold">
          <NumberInput
            {...form.getInputProps("minDiffThreshold")}
            defaultValue={100}
          />
        </InputWrapper>
        <InputWrapper label="Relative diff threshold">
          <NumberInput
            {...form.getInputProps("relativeDiffThreshold")}
            defaultValue={0.01}
          />
        </InputWrapper>
      </Group>
    </Stack>
  )
}
